import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface SongMetadataFieldsProps {
  utgivelsesaar: number | '';
  bpm: number | '';
  takt: string;
  lengdeMinutter: number | '';
  lengdeSekunder: number | '';
  onUtgivelsesaarChange: (value: number | '') => void;
  onBpmChange: (value: number | '') => void;
  onTaktChange: (value: string) => void;
  onLengdeMinutterChange: (value: number | '') => void;
  onLengdeSekunderChange: (value: number | '') => void;
}

export const SongMetadataFields: React.FC<SongMetadataFieldsProps> = ({
  utgivelsesaar,
  bpm,
  takt,
  lengdeMinutter,
  lengdeSekunder,
  onUtgivelsesaarChange,
  onBpmChange,
  onTaktChange,
  onLengdeMinutterChange,
  onLengdeSekunderChange,
}) => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
      <div className="space-y-2">
        <Label htmlFor="year">Utgivelsesår</Label>
        <Input
          id="year"
          type="number"
          placeholder="f.eks. 1982"
          value={utgivelsesaar}
          onChange={(e) => onUtgivelsesaarChange(e.target.value ? Number.parseInt(e.target.value, 10) : '')}
          min="1000"
          max={new Date().getFullYear() + 1}
          className="bg-slate-50/50 focus:bg-white"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="bpm">BPM</Label>
        <Input
          id="bpm"
          type="number"
          placeholder="f.eks. 120"
          value={bpm}
          onChange={(e) => onBpmChange(e.target.value ? Number.parseInt(e.target.value, 10) : '')}
          min="1"
          max="399"
          className="bg-slate-50/50 focus:bg-white"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="takt">Takt</Label>
        <Input
          id="takt"
          type="text"
          placeholder="f.eks. 4/4"
          value={takt}
          onChange={(e) => onTaktChange(e.target.value)}
          onKeyDown={(e) => {
            const currentValue = takt;
            
            if ((e.key === 'Tab' || e.key === ' ') && currentValue && /^\d+$/.test(currentValue)) {
              e.preventDefault();
              onTaktChange(currentValue + '/');
              if (e.key === 'Tab') {
                setTimeout(() => {
                  const input = document.getElementById('takt') as HTMLInputElement;
                  if (input) {
                    input.setSelectionRange((currentValue + '/').length, (currentValue + '/').length);
                  }
                }, 0);
              }
            }
          }}
          className="bg-slate-50/50 focus:bg-white"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="minutes">Min</Label>
        <Input
          id="minutes"
          type="number"
          placeholder="0"
          value={lengdeMinutter}
          onChange={(e) => onLengdeMinutterChange(e.target.value ? Number.parseInt(e.target.value, 10) : '')}
          min="0"
          className="bg-slate-50/50 focus:bg-white"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="seconds">Sek</Label>
        <Input
          id="seconds"
          type="number"
          placeholder="0"
          value={lengdeSekunder}
          onChange={(e) => onLengdeSekunderChange(e.target.value ? Number.parseInt(e.target.value, 10) : '')}
          min="0"
          max="59"
          className="bg-slate-50/50 focus:bg-white"
        />
      </div>
    </div>
  );
};

